import { z } from 'zod';
import { emailValidationSchema } from '@/schemas/ValidationSchema.ts';
import Role from '@/features/auth/login/types/Role';

export const inviteUserSchema = z.object({
  email: emailValidationSchema,
  role: z.enum([Role.Owner, Role.User], {
    error: 'Rola jest wymagana',
  }),
});

export type InviteUserFormData = z.infer<typeof inviteUserSchema>;
